import { createMiddleware } from "@tanstack/react-start";

/**
 * Client-side function middleware: attaches the current Supabase session's
 * access token as an Authorization header on every server-function RPC,
 * so server-side auth checks (e.g. manageKnowledge) see the caller's JWT.
 */
export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(async ({ next }) => {
  let headers: Record<string, string> = {};
  if (typeof window !== "undefined") {
    // Dynamic import keeps the Supabase client out of server module scope.
    const { supabase } = await import("./client");
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (session?.access_token) {
      headers = { Authorization: `Bearer ${session.access_token}` };
    }
  }
  return next({ headers });
});
